import React, { useState, Suspense, lazy } from 'react'
import { PageSpecificSchema } from '@ashleynexvelsolutions/page-specific-schema'
import { Breadcrumb } from '@ashleynexvelsolutions/breadcrumb'
import { InteriorContentV2 } from '@ashleynexvelsolutions/interior-content-v2'
import { InteriorHeadings } from '@ashleynexvelsolutions/interior-headings'
import { Seo2 } from '@ashleynexvelsolutions/seo2'
import { graphql, Script } from 'gatsby'
import { Layout } from '../components/Layout'
import {
  SeoFunction,
  PageSpecificSchemaFunction,
  BreadcrumbFunction,
  InteriorHeadingsFunction,
  ContentSection1Function,
  InteriorCardsFunction,
  CalloutV12Function,
  ServiceAreasFunction,
  ContactFunction,
  FAQsFunction,
  ContentSection2Function,
  CouponFunction,
  Callout2Function,
  MultiStepFormFunction,
  CouponPageFunction,
  ContentSection3Function,
  ContentSectionAccordionsFunction,
} from '../DataImports'
import { useCouponSectionQuery } from '../hooks/use-coupon-section-query'
import { CouponV3 } from '@ashleynexvelsolutions/coupon-v3'
import { ButtonV14 } from '@ashleynexvelsolutions/button-v14'

const InteriorCards = lazy(() =>
  import('@ashleynexvelsolutions/interior-cards').then(module => ({
    default: module.InteriorCards,
  })),
)

const CalloutV12 = lazy(() =>
  import('@ashleynexvelsolutions/callout-v12').then(module => ({
    default: module.CalloutV12,
  })),
)

const ServiceAreasV12 = lazy(() =>
  import('@ashleynexvelsolutions/service-areas-v12').then(module => ({
    default: module.ServiceAreasV12,
  })),
)

const ContactV6 = lazy(() =>
  import('@ashleynexvelsolutions/contact-v6').then(module => ({
    default: module.ContactV6,
  })),
)
const FaqV3 = lazy(() =>
  import('@ashleynexvelsolutions/faq-v3').then(module => ({
    default: module.FaqV3,
  })),
)
const ContentSection2 = lazy(() =>
  import('@ashleynexvelsolutions/content-section-2').then(module => ({
    default: module.ContentSection2,
  })),
)
const CalloutV13 = lazy(() =>
  import('@ashleynexvelsolutions/callout-v13').then(module => ({
    default: module.CalloutV13,
  })),
)
const MultiStepFormV7 = lazy(() =>
  import('@ashleynexvelsolutions/multi-step-form-v7').then(module => ({
    default: module.MultiStepFormV7,
  })),
)
const Portal = lazy(() =>
  import('@ashleynexvelsolutions/portal').then(module => ({
    default: module.Portal,
  })),
)
const InteriorAccordions = lazy(() =>
  import('@ashleynexvelsolutions/interior-accordions').then(module => ({
    default: module.InteriorAccordions,
  })),
)

const Page = ({ data }) => {
  function showContentSection2Img(pageTitle) {
    switch (pageTitle) {
      case 'Coupons':
      case 'Contact':
      case 'Reviews':
      case 'Privacy Policy':
        return false
      default:
        return true
    }
  }
  const [formModal, setFormModal] = useState(false)

  const handleButton = () => setFormModal(true)
  const { wpPage } = useCouponSectionQuery()

  console.log(data.wpPage.contentSectionAccordion.contentSectionAccordion)
  return (
    <Layout>
      <main className="rfs:pt-10 container mx-auto 3xl:max-w-none bg-white lg:grid lg:grid-cols-[56%_32%] xl:grid-cols-[65%_23%] lg:gap-x-[12%]">
        <div>
          <div className="page">
            <div className="rfs:pt-8 xl:pb-2">
              <Breadcrumb {...BreadcrumbFunction(data)} />
            </div>
            <InteriorHeadings {...InteriorHeadingsFunction(data)} />
            <div className="rfs:pt-8">
              {data.wpPage.title === 'Reviews' && (
                <div className="mb-6">
                  <Script id="reviewScript" src={process.env.GATSBY_BIRDEYE_REVIEW_URL} />
                  <div id={process.env.GATSBY_BIRDEYE_REVIEW_ID} />
                </div>
              )}
              <InteriorContentV2 {...ContentSection1Function(data)} />
            </div>
          </div>
          {data.wpPage.title === 'Coupons' && (
            <div className="grid xl:grid-cols-2 rfs:mb-24">
              {wpPage.couponSection.couponSection.coupons.map(coupon => {
                return (
                  <Suspense key={coupon.text} fallback="loading">
                    <div className="mb-4 mx-auto">
                      <CouponV3 {...CouponPageFunction(coupon)} />
                    </div>
                  </Suspense>
                )
              })}
            </div>
          )}
        </div>
        <aside className="rfs:gap-y-12 pt-4 lg:pt-6 3xl:pt-10">
          <div className="flex justify-center">
            <CouponV3 {...CouponFunction()} />
          </div>

          <div className="max-w-[80%] mx-auto rfs:mt-[3.16rem]">
            <ButtonV14
              rounded={false}
              notLink={false}
              href="/about/coupons/"
              label="View All"
              borderColor="border-blue"
              fontWeight="font-black"
              fontSize="text-lg lg:text-2xl"
              fontFamily="font-primary"
              bgColor="bg-blue"
              textColor="text-white"
              hoverBgColor="hover:bg-orange"
              hoverBorderColor="hover:border-orange"
              hoverTextColor="hover:text-white"
              padding="py-5 px-0"
            />
          </div>
        </aside>
      </main>
      <div className="bg-white container mx-auto 3xl:max-w-none overflow-x-hidden">
        {data.wpPage.interiorCards.interiorCards.cards !== null && (
          <Suspense fallback="loading">
            <InteriorCards {...InteriorCardsFunction(data)} />
          </Suspense>
        )}
        <Suspense fallback="loading">
          <div
            className={`rfs:mt-20 ${data.wpPage.nexvelschemapagesposts.questionsAndAnswers !== null && `rfs:pb-36`} `}
          >
            <CalloutV12 {...CalloutV12Function(handleButton)} />
          </div>
        </Suspense>
      </div>
      {data.wpPage.contentSectionAccordion.contentSectionAccordion.accordion !== null && (
        <Suspense fallback="loading">
          <div className="container mx-auto rfs:-mt-32">
            <InteriorAccordions {...ContentSectionAccordionsFunction(data)} />
          </div>
        </Suspense>
      )}
      {data.wpPage.nexvelschemapagesposts.questionsAndAnswers !== null && (
        <Suspense fallback="loading">
          <FaqV3 {...FAQsFunction(data)} />
        </Suspense>
      )}
      <Suspense fallback="loading">
        <ContentSection2
          showImg={showContentSection2Img(data.wpPage.title)}
          {...ContentSection2Function(data)}
        />
      </Suspense>
      <Suspense fallback="loading">
        <div
          className={`pt-[10rem] lg:pt-0 container mx-auto ${data.wpPage.weatherWidgetRelatedLinks.weatherWidgetRelatedLinks.text === null && `rfs:pb-[10rem]`}`}
        >
          <CalloutV13 {...Callout2Function(handleButton)} />
        </div>
      </Suspense>
      <Suspense fallback="loading">
        {data.wpPage.contentSection3.contentSection3 !== null && (
          <div className="container page mx-auto rfs:mt-20 rfs:pb-[10rem]`}">
            <InteriorContentV2 {...ContentSection3Function(data)} />
          </div>
        )}
      </Suspense>
      {data.wpPage.weatherWidgetRelatedLinks.weatherWidgetRelatedLinks.text !== null && (
        <div className="container mx-auto rfs:mt-20 rfs:pb-[10rem]`}">
          <div
            className="page"
            dangerouslySetInnerHTML={{
              __html: data.wpPage.weatherWidgetRelatedLinks.weatherWidgetRelatedLinks.text,
            }}
          />
        </div>
      )}
      <Suspense fallback="loading">
        <ServiceAreasV12 {...ServiceAreasFunction(handleButton)} />
      </Suspense>
      <Suspense fallback="loading">
        <ContactV6 {...ContactFunction()} />
      </Suspense>
      <Suspense fallback="loading">
        {formModal === true && (
          <Portal
            isOpen
            onClose={() => setFormModal(false)}
            xColor="text-blue"
            maxWidth="max-w-full"
            padding="p-0"
            width="w-full lg:w-auto"
            background="bg-white/[0.9]"
          >
            <MultiStepFormV7 {...MultiStepFormFunction()} />
          </Portal>
        )}
      </Suspense>
      <PageSpecificSchema {...PageSpecificSchemaFunction(data)} />
    </Layout>
  )
}
export const query = graphql`
  query ($id: String!) {
    wpPage(id: { eq: $id }) {
      seo {
        title
        metaDesc
        opengraphTitle
        opengraphDescription
        opengraphUrl
        opengraphSiteName
        opengraphType
        opengraphImage {
          localFile {
            publicURL
          }
        }
        canonical
        twitterTitle
        twitterDescription
        twitterImage {
          localFile {
            publicURL
          }
        }
      }
      nexvelschemapagesposts {
        videos {
          title
          url
          description
          thumbnailImage {
            localFile {
              publicURL
            }
          }
          uploadDate
        }
        questionsAndAnswers {
          question
          answer
        }
        maps {
          mapUrl
        }
        digitaldocuments {
          title
        }
        images {
          image {
            localFile {
              publicURL
            }
            date(formatString: "LL")
            description
            title
          }
        }
        areaServedLandingPageSchema
        serviceSchema {
          serviceNameSchema
          linkToRelevantServicePageSchema
        }
        keywordsSchema {
          keywordSchema
        }
        localAwardsSchema {
          localAwardSchema
        }
        latitudeSchema
        longitudeSchema
        relevantExternalPagesSchema {
          relevantExternalPageSchema
        }
      }

      breadcrumbs {
        breadcrumbs {
          breadcrumbs
        }
      }

      title
      uri
      faqs {
        faqs {
          title
        }
      }
      contentSection2 {
        contentSection2 {
          title
          text
          desktopImage {
            sourceUrl
            mediaDetails {
              width
              height
            }
          }
          desktopImageAltText
          hasAccordions
          accordions {
            label
            text
          }
          textNoAccordions
        }
      }
      weatherWidgetRelatedLinks {
        weatherWidgetRelatedLinks {
          text
        }
      }

      interiorHeadings {
        interiorHeadings {
          headings
        }
      }
      contentSection1 {
        contentSection1
      }
      contentSection3 {
        contentSection3
      }
      interiorCards {
        interiorCards {
          cards {
            icon {
              localFile {
                publicURL
              }
            }
            title
            text
          }
          buttonText
        }
      }
      contentSectionAccordion {
        contentSectionAccordion {
          accordion {
            label
            content1
            content2
            image {
              sourceUrl
            }
          }
        }
      }
      weatherWidgetRelatedLinks {
        weatherWidgetRelatedLinks {
          text
        }
      }
      title
      uri
    }
    wp {
      nexvelSchemaMarkup {
        nexvelschema {
          cities {
            city
          }
          services {
            service
            linkToRelevantPageOnYourWebsite
          }
        }
      }
    }
    site {
      siteMetadata {
        siteUrl
      }
    }
  }
`
export default Page
export const Head = ({ data }) => <Seo2 {...SeoFunction(data)} />
